'use strict';

var iconCaseSpotMarker = function(data) {
    return L.divIcon({
        className: 'spot-div-icon',
        iconSize: new L.Point(36, 36),
    });
};

L.Cyclone.SpotMarker = L.Cyclone.Marker.extend({

    options: {
        tagVisible: false,
        iconCase: iconCaseSpotMarker,
        radius: {
            visible: true,
            // Also could be
            //    visible: {
            //        r7: true
            //        r10: false
            //    }

            //
            // Here is a special property to convert real radius data value
            // to meter for L.circle.
            // Exp(trans km to meter):
            //    unitConverter : function(val) { return val * 1000; }
            //
            unitConverter: null
        },
        markerMove: null,
        clickable: false
    },

    initialize: function (options) {
        L.setOptions(this, options);

        this.options.radius = L.extend({}, options.radius);

        this._radius_layers = {};
        this._data = L.extend({
            lat: null,
            lon: null,
            ws: null,
            radius: null
        }, this._data);
        this._initData(this._data, true);
    },

    changeTo: function(data) {
        var self = this,
            _latLng = L.latLng(data.lat, data.lon);

        self._data = data;
        self._data.radius = {};
        if (data.r7) {
            self._data.radius.r7 = data.r7;
        }
        // if (data.r10) {
        //     self._data.radius.r10 = data.r10;
        // }

        if (self._data.lat > -99 && _latLng) {
            self.setLatLng(_latLng);
            self._markerMove();

            for (var key in self._radius_layers) {
                if (self._radius_layers[key]) {
                    if (self._map) {
                        self._map.removeLayer(self._radius_layers[key]);
                    }
                    self._radius_layers[key] = null;
                }
            }
            self._radius_layers = {};

            if (self._map && self._data.radius) {
                self._initRadius();
            }
        }

        return self;
    },

    has_data: function() {
        if (this._data) {
            let _latLng = L.latLng(this._data.lat, this._data.lon);
            return _latLng && (this._data.lat > -99);
        }
        return false;
    },

    clear_data: function() {
        this._data = null;
        return this;
    }

});


export class TcSpotHandler {

    constructor(map, visible) {
        this.map = map;
        this.visible = visible;
    };

    _clear_tcs(layers) {
        for (let tc_name in layers) {
            this.map.removeLayer(layers[tc_name]);
            layers[tc_name] = null;
        }
    };

    clear_tcs() {
        if (this.layers) {
            for (let src_id in this.layers) {
                this._clear_tcs(this.layers[src_id]);
                this.layers[src_id] = {};
            }
        }
    };

    clear() {
        if (this.layers) {
            for (let src_id in this.layers) {
                this._clear_tcs(this.layers[src_id]);
                this.layers[src_id] = null;
            }
        }
        this.layers = {};
    };

    set_srcs(srcs) {
        this.clear();
        this.srcs = srcs;
        this.visible_src = {};
        for (let src_obj of srcs) {
            this.layers[src_obj.id] = {};
            this.visible_src[src_obj.id] = src_obj.selected;
        }
        this.set_tc_infos();
    };

    set_tc_infos(tc_infos) {
        if (tc_infos) {
            this.clear_tcs();
            this.tc_infos = tc_infos;
        }

        if (this.tc_infos) {
            this.visible_tc = {};
            for (let tc_obj of this.tc_infos) {
                for (let src_id in this.layers) {
                    this.layers[src_id][tc_obj.name] = this._create_layer(src_id);
                }
                this.visible_tc[tc_obj.name] = tc_obj.selected;
            }
            this.reset_place();
        }
    };

    _create_layer(src_id) {
        let color = "#ccc";
        for (let src_obj of this.srcs) {
            if (src_obj.id == src_id) {
                color = src_obj.color;
                break;
            }
        }

        return new L.Cyclone.SpotMarker({
            radius: {
                r7: {
                    weight: 1,
                    color: color,
                    opacity: 0.8,
                    fillOpacity: 0.2,
                    great_circle: true,
                    density: 1,
                    smoothFactor: 0.1
                },
                visible: true
            },
            zIndexOffset: -1000
        });
    };

    set_dtg(dtg) {
        dtg = Date.dtgptime(dtg).setMinutes(0, 0, 0).valueOf();
        if (this.dtg !== dtg) {
            this.dtg = dtg;
            this.reset_place();
        }
    };

    set_tracks(tracks) {
        this.tracks = tracks;
        this.reset_place();
    };

    reset_place() {
        for (let src_id in this.layers) {
            let src_tcs = this.layers[src_id];

            for (let tc_name in src_tcs) {
                let ly = src_tcs[tc_name];
                let has_data = false;

                // find src+tc data at dtg
                if (this.tracks) {
                    for (let track of this.tracks) {
                        if (track.src == src_id && track.tc_name == tc_name) {
                            let init = Date.dtgptime(track.init_time_z);
                            for (let point of track.track) {
                                let dtime = init.addHours(point.tau).valueOf();
                                if (dtime == this.dtg) {
                                    ly.changeTo(point);
                                    has_data = true;
                                    break;
                                }
                            }
                            if (has_data) { break; }
                        }
                    }
                }

                // if no data, clear layer
                if (!has_data) {
                    ly.clear_data();
                }
            }
        };
        this.reset_visible();
    };

    set_visible(visible) {
        this.visible = visible;
        this.reset_visible();
    };

    set_src_visible(selected_srcs) {
        for (let src_id in this.visible_src) {
            if (selected_srcs.indexOf(src_id) >= 0) {
                this.visible_src[src_id] = true;
            }
            else {
                this.visible_src[src_id] = false;
            }
        }
        this.reset_visible();
    };

    set_tc_visible(selected_tcs) {
        for (let tc_name in this.visible_tc) {
            if (selected_tcs.indexOf(tc_name) >= 0) {
                this.visible_tc[tc_name] = true;
            }
            else {
                this.visible_tc[tc_name] = false;
            }
        }
        this.reset_visible();
    };

    reset_visible() {
        for (let src_id in this.layers) {
            for (let tc_name in this.layers[src_id]) {
                let ly = this.layers[src_id][tc_name];
                if (this.visible) {
                    if (this.visible_src[src_id] && this.visible_tc[tc_name] && ly.has_data()) {
                        this.map.addLayer(ly);
                    }
                    else {
                        this.map.removeLayer(ly);
                    }
                }
                else {
                    this.map.removeLayer(ly);
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/js/tc_spot.js